export class EventBus {
    subscribers = {};
    subjectsStateMap = {};
    subscribe(type, listener) {
        this.subscribers[type] = (this.subscribers[type] || []).concat(listener);
        const latestEvent = this.subjectsStateMap[type];
        if (latestEvent) {
            listener(latestEvent);
        }
        return () => {
            this.unsubscribe(type, listener);
        };
    }
    unsubscribe(type, listener) {
        this.subscribers[type] = this.subscribers[type]?.filter((s) => s !== listener);
    }
    fire(type, event) {
        const isSubjectDeclared = type in this.subjectsStateMap;
        if (isSubjectDeclared) {
            this.subjectsStateMap[type] = event;
        }
        this.subscribers[type]?.forEach((s) => s(event));
    }
    subject(type, event) {
        this.subjectsStateMap[type] = event;
    }
}
//# sourceMappingURL=EventBus.js.map